import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const linxIntegrationSchema = z.object({
  id: zExt.objectId(),
  enabled: z.boolean(),
  baseUrl: z.string(),
  apiKeyPreview: z.string(),
  apiSecretPreview: z.string(),
  source: z.string(),
  store: z.string(),
  storeId: z.number().nullable(),
});

export const linxSettingsInputSchema = z.object({
  enabled: z.boolean().optional(),
  baseUrl: z.string().url().optional(),
  apiKey: z.string().min(1).optional(),
  apiSecret: z.string().min(1).optional(),
  source: z.string().min(1).optional(),
  store: z.string().min(1).optional(),
  storeId: z.number().int().nullable().optional(),
});
